import React from 'react';
import { motion } from 'motion/react';
import styles from './PageHeader.module.css';
import { staggerContainer, staggerItem } from '../../utils/motion';

const container = staggerContainer(0.07);

export default function PageHeader({ title, subtitle, breadcrumb, className = '' }) {
  return (
    <motion.header
      className={`${styles.header} ${className}`}
      variants={container}
      initial="hidden"
      animate="visible"
    >
      {breadcrumb && (
        <motion.p className={styles.breadcrumb} variants={staggerItem}>
          {breadcrumb}
        </motion.p>
      )}
      <motion.h1 className={styles.title} variants={staggerItem}>
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p className={styles.subtitle} variants={staggerItem}>
          {subtitle}
        </motion.p>
      )}
    </motion.header>
  );
}
